import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './locales/resources';
import url from './utils/url-utils';
import { QueryParamKey } from './provider/bundle';
// import LanguageDetector from "i18next-browser-languagedetector";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const lng = url.getQueryVariable(QueryParamKey.LANGUAGE);
i18n
    // .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: 'en',
        resources,
        lng: lng ? lng.replace('_', '-') : undefined, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
